import { Check } from "lucide-react";
import { ASSUNTOS_POR_ETAPA, OUTROS } from "@/data/assuntos";

const AssuntosPicker = ({ etapaNome, assuntos, onToggle, outrosTexto, onOutrosChange, inputClass, label = "Assuntos de interesse" }) => {
  const lista = ASSUNTOS_POR_ETAPA[etapaNome];
  if (!etapaNome || !lista) return null;
  return (
    <div data-testid="assuntos-picker">
      <label className="block text-sm font-medium text-maternnia-charcoal mb-2.5">{label}</label>
      <div className="flex flex-wrap gap-2">
        {[...lista, OUTROS].map((a) => {
          const ativo = assuntos.includes(a);
          return (
            <button
              key={a} type="button" data-testid={`assunto-${a}`} onClick={() => onToggle(a)}
              className={`text-xs font-medium rounded-full px-3.5 py-1.5 transition-all duration-300 ${ativo ? "bg-maternnia-eucalipto text-white" : "bg-maternnia-porcelana text-maternnia-taupe hover:bg-maternnia-nevoa"}`}
            >
              {ativo && <Check size={12} className="inline mr-1 -mt-0.5" />}{a}
            </button>
          );
        })}
      </div>
      {assuntos.includes(OUTROS) && (
        <input
          data-testid="assunto-outros-texto" type="text" value={outrosTexto}
          onChange={(e) => onOutrosChange(e.target.value)}
          placeholder="Conte qual outro assunto"
          className={`${inputClass} mt-2.5`}
        />
      )}
    </div>
  );
};

export default AssuntosPicker;
